import React from "react";

export function renderEditor(props) {
  const { selectedValue, setSelectedValue, options } = props;
  const { geometry } = props.annotation;

  if (!geometry) return null;

  const handleSelectChange = (e) => {
    const value = e.target.value;
    setSelectedValue(value);
    props.onChange({
      ...props.annotation,
      data: {
        ...props.annotation.data,
        text: value,
      },
    });
  };

  return (
    <div
      className="position-absolute bg-white rounded p-2"
      style={{
        left: `${geometry.x}%`,
        top: `${geometry.y + geometry.height}%`,
      }}
    >
      <select
        className="form-select mb-2"
        onChange={handleSelectChange}
        value={selectedValue}
      >
        <option value="">
          Select Label
        </option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <button
        className="btn btn-primary"
        onClick={props.onSubmit}
        disabled={!selectedValue}
      >
        Add Label
      </button>
    </div>
  );
}
